import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { useParams } from "react-router-dom";

import Contacts from "components/Contacts";
import Layout from "components/Layout";
import Scrollable from "components/Scrollable";
import withAuth from "components/withAuth";
import isEmpty from "utils/isEmpty";

import { H2, Section } from "styles";
import { CONTACT } from "queries";

function Contact() {
  const { slug, id } = useParams() as { slug: string; id: string };
  const { data: { contacts } = { contacts: [] } } = useQuery(CONTACT);

  return (
    <Layout>
      <Section>
        <H2>Contacts</H2>
        <Scrollable>
          {!isEmpty(contacts) && (
            <Contacts contacts={contacts} slug={slug} id={id} />
          )}
        </Scrollable>
      </Section>
    </Layout>
  );
}

export default withAuth(Contact);
